import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isNative } from '@bubble-ui/util-platform';
import { smallVerticalSpacing, bulletSize, commonGutterStyle, titleInformationOverride } from './style';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    small
  } = _ref;
  var sharedGutterStyle = commonGutterStyle(designContext);
  return {
    rootStyle: {},
    gutterContainerStyle: {
      flexDirection: 'row'
    },
    firstGutterStyle: _objectSpread(_objectSpread({}, sharedGutterStyle), {}, {
      top: smallVerticalSpacing
    }),
    gutterStyle: _objectSpread({}, sharedGutterStyle),
    lastGutterStyle: _objectSpread(_objectSpread({}, sharedGutterStyle), {}, {
      height: smallVerticalSpacing
    }),
    continousGutterContainerStyle: _objectSpread(_objectSpread({}, sharedGutterStyle), {}, {
      flexDirection: 'column',
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString()
    }),
    continousGutterStyle: {
      backgroundColor: sharedGutterStyle.backgroundColor,
      height: 38
    },
    continousGutterTrailStyle: {
      backgroundColor: sharedGutterStyle.backgroundColor,
      height: 2,
      marginTop: 4
    },
    entryContainerStyle: {
      flexDirection: 'row'
    },
    entryBulletContainerStyle: {
      paddingTop: smallVerticalSpacing,
      paddingRight: smallVerticalSpacing
    },
    entryContentContainerStyle: {
      flexShrink: 1,
      width: '100%',
      paddingTop: smallVerticalSpacing
    },
    entryTitleContainerStyle: {
      paddingBottom: smallVerticalSpacing
    },
    entryDescriptionContainerStyle: {
      paddingBottom: smallVerticalSpacing
    },
    entryCustomContentContainerStyle: {
      paddingBottom: smallVerticalSpacing
    },
    // Overriding Title.Information
    entryTitleTextStyle: titleInformationOverride(designContext, small),
    paragraphTertiaryCorrectFootprintLightStyle: _objectSpread(_objectSpread({
      color: designContext.get('timeline/description-color').toString()
    }, designContext.get('timeline/description-text-style').styles()), {}, {
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word',
      marginBottom: -10,
      marginTop: -5
    }, isNative ? {
      paddingBottom: 5,
      paddingTop: 0
    } : {
      paddingBottom: 4,
      paddingTop: 1
    }),
    bulletStyle: {
      fill: designContext.get('timeline/bullet-color').toString(),
      width: bulletSize,
      height: bulletSize
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map